import { combineReducers } from "redux";
import ui from "./reducers/ui";
import data from './reducers/data';

const rootReducer = combineReducers({
  ui, data
});

export default rootReducer;
